import { ICalendar } from "datebook";

window.calendar = () => {
    return {
        title: "",
        url: "",
        startDate: "",
        endDate: "",

        download() {
            const icalendar = new ICalendar({
                title: this.title,
                location: this.url,
                start: new Date(this.startDate * 1000),
                end: new Date(this.endDate * 1000),
            });
            icalendar.download();
        },
    };
};
